Customer.Views ||= {}
Customer.Views.Insights ||= {}

class Customer.Views.Insights.OperatorActivityResultsView extends Backbone.View
  templates:
    detail:
      JST["backbone/templates/customer/insights/operator_status_activity/detail_by_operator"]
    summary:
      JST["backbone/templates/customer/insights/operator_status_activity/detail_by_period"]
    daily_summary:
      JST["backbone/templates/customer/insights/operator_status_activity/detail_by_day"]


  initialize: ({results, statuses, timezone}) ->
    @results = results
    @statuses = statuses
    @timezone = timezone

  render: ->
    $('#activity-results').html @templates[@results['report_type']]
      results: @results
      statuses: @statuses
      timezone: @timezone
    @
